module.exports = __webpack_public_path__ + "static/media/location.9412304b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/location.svg
// module id = 174
// module chunks = 0